import { render, staticRenderFns } from "./PurchaseReturnDetailQuery.vue?vue&type=template&id=7556067c&scoped=true"
import script from "./PurchaseReturnDetailQuery.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturnDetailQuery.vue?vue&type=style&index=0&id=7556067c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7556067c",
  null
  
)

export default component.exports